export type OneDrivePostMessageType = {
	data: {
		type: string;
		actionType: OneDriveActionTypes;
		pickerData: FilesResponseType;
	};
};

export enum OneDriveActionTypes {
	CLICK = 'click',
	INIT = 'init',
	UNMOUNT = 'unmount',
	SUCCESS = 'success',
	CANCEL = 'cancel',
	ERROR = 'error',
}

// Full list of available fields: https://developers.google.com/picker/docs/reference#document
export type OneDrivePickerDoc = {
	id: string;
	name: string;
	lastEditedUtc: number;
};

export type OneDriveType = {
	open: (props: OneDrivePickerOptions) => void;
};

declare global {
	interface Window {
		OneDrive: OneDriveType;
	}
}

export enum OneDrivePickerActions {
	SHARE = 'share',
	QUERY = 'query',
	DOWNLOAD = 'download',
}

export type OneDrivePickerOptions = {
	clientId: string;
	action: OneDrivePickerActions;
	multiSelect?: true;
	advanced: {};
	success: (files: FilesResponseType) => void;
	cancel?: () => void;
	error: (e: any) => void;
};

//details here https://docs.microsoft.com/en-us/onedrive/developer/controls/file-pickers/js-v72/open-file?view=odsp-graph-online#4-handling-the-picker-response-object
export type OneDriveFileType = {
	'@microsoft.graph.downloadUrl': string;
	'@odata.context': string;
	id: string;
	name: string;
	size: number;
};

export type FilesResponseType = {
	value: OneDriveFileType[];
};

export enum OneDriveErrorStatuses {
	NO_ACCESS = 403,
}

export type OneDriveCredentials = {
	clientId: string;
};
